import { render, staticRenderFns } from "./FoldingContainer.vue?vue&type=template&id=5d4e1adf&scoped=true&"
import script from "./FoldingContainer.vue?vue&type=script&lang=js&"
export * from "./FoldingContainer.vue?vue&type=script&lang=js&"
import style0 from "./FoldingContainer.vue?vue&type=style&index=0&id=5d4e1adf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e1adf",
  null
  
)

export default component.exports